import React from 'react';
import { NavBar, ghost } from '@minerva-analytics/pantheon';
import { GHOST_API } from '../../constants';
import { WHITE, DARK_SKY } from '../../theme';

const Nav = () => {
  const { selectArticle } = ghost.hooks.useGhostActions(GHOST_API);

  const dealsOnClick = () => {
    selectArticle(`deals`);
  }

  const links = [
    {
      to: '/about',
      title: 'ABOUT',
    },
    {
      to: '/articles',
      title: 'NEWS',
    },
    {
      to: '/newsletterpreview',
      title: 'NEWSLETTER',
    },
    {
      to: '/articles/deals',
      title: 'SHOP',
      onClick: dealsOnClick,
    },
  ];

  return (
    <NavBar
      links={links}
      font='Roboto'
      mobileLogo="https://storage.googleapis.com/quickscope/assets/quickscope_favicon.png"
      logo="https://storage.googleapis.com/quickscope/assets/QuickScope_Logo.png"
      menuItemColor={WHITE}
      headerColor={DARK_SKY}
      menuColor={DARK_SKY}
      menuIconColor={WHITE}
      menuDividerColor='rgba(255,255,255,.15)'
      desktopHoverState={{
        fontWeight: `500`,
        cursor: `pointer`,
      }}
    />
  );
};

export default Nav;